
    import '/mnt/src/components/Stepper/index.md?watch=parent';
    export const demoIndex = {
  ids: ["stepper-demo-basicdemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Stepper/index.md?type=demo')
};